export function isPlaying(state) {
    return !state.project.isEmbedded || state.player.isPlaying;
}
